var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"checked-items-visible-toggle icon",class:{visible: _vm.checkedItemsVisible},on:{"click":_vm.toggleCheckedVisibility}},[_c('v-icon',{attrs:{"name":"eye"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }